<template>
  <div class="account-mapping-search__container">
    <sf-search-input
      id="main-search"
      :placeholder="placeholder"
      :show-result-navigation="false"
      :show-clear-icon="!!commonStore.searchTerm"
      :model-value="commonStore.searchTerm"
      :focused-at="commonStore.remapSearchFocusedAt"
      @update:modelValue="updateGroupSearch"
      @clear="handleClearSearch"
    />
  </div>
</template>

<script setup lang="ts">
import SfSearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import { useCommon } from '@app/application/account-mapping/store/common'
import { useSearch } from '@app/application/account-mapping/store/search'

const commonStore = useCommon()
const searchStore = useSearch()

const placeholder = window.I18n.t(
  'account_mapping_list.remap.search_placeholder'
)

const updateGroupSearch = (value: string | null) => {
  if (value) {
    searchStore.setRemapDropdownShowAllGroups(true)
    commonStore.searchFor(value)
  } else {
    commonStore.clearSearch()
  }
}

const handleClearSearch = () => {
  commonStore.clearSearch()
}
</script>

<style scoped lang="scss">
.account-mapping-search__container {
  flex: 1 0 auto;
}
</style>
